import { render, staticRenderFns } from "./rulePop.vue?vue&type=template&id=00ce56d6&scoped=true&"
import script from "./rulePop.vue?vue&type=script&lang=js&"
export * from "./rulePop.vue?vue&type=script&lang=js&"
import style0 from "./rulePop.vue?vue&type=style&index=0&id=00ce56d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce56d6",
  null
  
)

export default component.exports